
const digest = '4aa9ec6732544ba6c264bb1e08ca11e2d93db9fb8821a88c9a072629aed0b909';
const css = `body {
  /**
   * Styling of buttons and other controls in this toolbar.
   * Note that toolbar, elementToolbar and selectionToolbar all use the same
   * components with different variable settings.
   * These are defined globally at the root so it can be accessed in the floating element toolbars
   */
  --editor-v2-toolbar-font-size: 13px;
  --aha-editor--user-line-height: 1.5;
  --editor-v2-toolbar-button-size: 24px;
  --editor-v2-toolbar-button-font-size: 14px;
  --editor-v2-toolbar-button-radius: 4px;
  --editor-v2-toolbar-button-color: var(--theme-primary-text);
  --editor-v2-toolbar-button-background-color: var(--theme-editor-button);

  --aha-editor-v2--background-color: var(--theme-primary-background);
  --aha-editor-v2--border-radius: var(--spacer-1);
  --aha-editor-v2--border-color: var(--theme-primary-border);
  --aha-editor-v2--border-hover-color: rgba(0, 115, 207, 0.2);
  --aha-editor-v2--border-width: 1px;
  --aha-editor-v2--focused-border-color: #88bbe4;
  --aha-editor-v2--focused-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 0 2px rgba(82, 168, 236, 0.5);
  --aha-editor-v2--selection-background-color: var(--rgb-gray-500);
  --aha-editor-v2--selection-outline-color: var(--rgb-gray-500);
  --aha-editor-v2--content-padding: 4px;
}

._wrapper_1fjob_29 {
  display: flex;
  flex-direction: row;

  &._fullScreen_1fjob_33 {
    position: fixed;
    left: 0;
    right: 0;
    /* 36px is the top bar height */
    top: var(--aha-editor--topbar-height) !important;
    height: calc(100% - var(--aha-editor--topbar-height));
    margin: 0;
    border: 0;
    overflow: hidden;
    box-shadow: none;
    z-index: 9998;
  }
}

._container_1fjob_48 {
  --aha-editor-v2--monospace-fonts: Monaco, Menlo, Consolas, Courier New,
    monospace;

  position: relative;
  width: 100%;
  height: 100%;

  /* This is needed to prevent the editor container from taking up too much width in the flex row */
  min-width: 0;

  /* Styles for blurred editor. */
  &._blurred_1fjob_60 {
    ._body_1fjob_61 {
      /* Clicking on a link when not focused will navigate, so show the pointer */
      a[href] {
        cursor: pointer;
      }
    }
  }
}

.dark-mode-allowed[data-theme='dark'] ._container_1fjob_48 {
  --aha-editor-v2--selection-background-color: var(--rgb-gray-600);
  --aha-editor-v2--selection-outline-color: var(--rgb-gray-600);
}

._showBorderNever_1fjob_75 {
  --aha-editor-v2--border-color: transparent;
  --aha-editor-v2--border-hover-color: transparent;
  --aha-editor-v2--border-width: 0;
}

._showBorderFocused_1fjob_81 {
  --aha-editor-v2--border-color: transparent;
}

._editor_1fjob_85 {
  position: relative;
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-color: var(--aha-editor-v2--border-color);
  border-width: var(--aha-editor-v2--border-width);
  border-radius: var(--aha-editor-v2--border-radius);
  background-color: var(--aha-editor-v2--background-color);
}

._selections_1fjob_96 {
  display: none;
  overflow: visible;
  position: relative;
}

._focused_1fjob_102 {
  outline: none;
  text-decoration: none;

  ._selections_1fjob_96 {
    display: block;
  }
}

/**
 * These '.focused' rules are below '.editor' so we can use cascading to override the above rules.
 */
._notFullScreen_1fjob_114 {
  ._showBorderAlways_1fjob_115,
  ._showBorderFocused_1fjob_81 {
    &._focused_1fjob_102 {
      ._editor_1fjob_85 {
        --aha-editor-v2--border-color: var(
          --aha-editor-v2--focused-border-color
        );
        box-shadow: var(--aha-editor-v2--focused-box-shadow);
      }
    }
  }

  ._editor_1fjob_85 {
    &:hover {
      --aha-editor-v2--border-color: var(--aha-editor-v2--border-hover-color);
    }
  }
}

._hiddenToolbar_1fjob_134 {
  ._toolbar_1fjob_135 {
    display: none;
  }

  &._focused_1fjob_102 ._toolbar_1fjob_135 {
    display: flex;
  }
}

._notFullScreen_1fjob_114 ._inline_1fjob_144 {
  ._toolbar_1fjob_135 {
    visibility: hidden;
    margin-top: calc(-1 * var(--aha-editor--toolbar-height));
  }

  &._blurred_1fjob_60 {
    ._anchor_1fjob_151 {
      pointer-events: none;
    }
  }

  &._focused_1fjob_102 {
    top: calc(-1 * var(--aha-editor--toolbar-height));
    margin-bottom: calc(-1 * var(--aha-editor--toolbar-height));

    ._toolbar_1fjob_135 {
      visibility: visible;
      margin-top: 0;
    }
  }
}

._content_1fjob_167 {
  flex: auto;
  flex-basis: 1px;
  padding: var(--aha-editor-v2--content-padding, var(--spacer-2));
  position: relative;
  z-index: 0;
  container-type: inline-size; /* Make this a container for container queries, so that setting 100cqw on the Resizer component knows just how wide to make the Resizer. */
}

._body_1fjob_61 {
  min-height: var(--aha-editor-v2--body-min-height, unset);
  position: relative;
  transform-origin: left top;
  transform: var(--aha-editor--body-transform, initial);
}

._hasContent_1fjob_183 {
  /* We only set this if there's content, otherwise these styles apply to the placeholder content, which is rendered in a single <p> */
  ._body_1fjob_61 {
    > p:last-child {
      --default-type-margin: 0;
      /* This variable is used by .user-content for styling static content */
      --aha-editor--block-margin: 0;
    }
  }
}

._isEmpty_1fjob_194 {
  ._body_1fjob_61 {
    ._placeholder_1fjob_196 {
      > p:last-child {
        --default-type-margin: 0;
        /* This variable is used by .user-content for styling static content */
        --aha-editor--block-margin: 0;
      }
    }
  }
}

._focused_1fjob_102 {
  --aha-editor-v2--selection-background-color: var(--rgb-blue-200);
  --aha-editor-v2--selection-outline-color: var(--rgb-blue-400);
}

._placeholder_1fjob_196 {
  font-family: var(--default-font-family);
  min-height: var(--aha-editor-v2--body-min-height, 1.5rem);
}

._fullScreen_1fjob_33 {
  .aha-editor-field-v2__sidepanel {
    margin-top: calc(var(--aha-editor--toolbar-height) + 1px);
  }

  &:has(._readOnly_1fjob_221) .aha-editor-field-v2__sidepanel {
    margin-top: 1px;
  }

  > ._container_1fjob_48 {
    ._editor_1fjob_85 {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      background-color: var(--theme-container-background);
    }

    ._content_1fjob_167 {
      background-color: var(--aha-editor-v2--background-color);
      display: flex;
      flex-direction: column;
      margin: 50px;
      margin-top: calc(50px + var(--aha-editor--toolbar-height));
      padding: 75px 100px;
      box-shadow: var(--aha-editor-body-with-toc-box-shadow);
      flex: 1;
    }

    &._focused_1fjob_102 {
      box-shadow: none;
      border-color: transparent;
    }
  }
}

._editable_1fjob_251 {
  ._content_1fjob_167 {
    /**
     * This might seem counter-intuitive, but a [contentEditable] is _always_ selectable.
     * The purpose of this CSS rule is prevent Slate from thinking content inside the '.container', but outside the '<Editable>', is selectable.
     * This fixes weird bugs where doing thngs like Cmd+A to select all text will seem to try and select OUTSIDE the editor content, thus leaving
     * an invalid selection range.
     *
     * Related bugs:
     *   - https://big.aha.io/develop/features/CREATE-2114
     *   - https://big.aha.io/develop/requirements/CREATE-1804-40
     *   - https://big.aha.io/features/ACT-1668
     *
     * Slate issue that gave me a hint to a solution:
     *   - https://github.com/ianstormtaylor/slate/issues/2500#issuecomment-471129827
     */
    user-select: none;
  }
}

/* Empty classes for now, used to flag readOnly/interactive behaviours in the DOM */
._readOnly_1fjob_221 {
}

._interactive_1fjob_275 {
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"wrapper":"_wrapper_1fjob_29","fullScreen":"_fullScreen_1fjob_33","container":"_container_1fjob_48","blurred":"_blurred_1fjob_60","body":"_body_1fjob_61","showBorderNever":"_showBorderNever_1fjob_75","showBorderFocused":"_showBorderFocused_1fjob_81","editor":"_editor_1fjob_85","selections":"_selections_1fjob_96","focused":"_focused_1fjob_102","notFullScreen":"_notFullScreen_1fjob_114","showBorderAlways":"_showBorderAlways_1fjob_115","hiddenToolbar":"_hiddenToolbar_1fjob_134","toolbar":"_toolbar_1fjob_135","inline":"_inline_1fjob_144","anchor":"_anchor_1fjob_151","content":"_content_1fjob_167","hasContent":"_hasContent_1fjob_183","isEmpty":"_isEmpty_1fjob_194","placeholder":"_placeholder_1fjob_196","readOnly":"_readOnly_1fjob_221","editable":"_editable_1fjob_251","interactive":"_interactive_1fjob_275"};
export { css, digest };
  